var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, InterfaceType } from "type-graphql";
import { GlobalIdScalar } from "./scalars/GlobalId.js";
let Node = class Node {
    id;
    text() {
        return this.id.id;
    }
};
__decorate([
    Field(() => GlobalIdScalar),
    __metadata("design:type", Object)
], Node.prototype, "id", void 0);
__decorate([
    Field(() => String, {
        description: "A human-readable string representing the object.",
    }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], Node.prototype, "text", null);
Node = __decorate([
    InterfaceType()
], Node);
export { Node };
//# sourceMappingURL=relay.js.map